export default "assets/images/icons/linkedin-6983bfb8.svg";